<template>
  <div>
    <div class="d-flex align-items-center mb-1">
      <b-avatar
        rounded
        size="32"
        variant="light-danger"
        class="mr-75 rpIcon"
      >
        ZTI
      </b-avatar>
      <div>
        <h4 class="mb-0">
          Zona Tarif Inner
        </h4>
        <!-- <b-link @click="detail()" class="title"><feather-icon
          icon="ArrowLeftIcon"
          size="16"
          style="margin-bottom:0.3rem;"
        />{{title}}</b-link> -->
      </div>
    </div>
    <b-modal size="lg" title="Non-Disclosure Agreement" v-model="show" centered hide-footer>
      <h5> Dengan ini saya menyetujui bahwa:</h5>
      <ol>
        <li>
          <h6>Seluruh Tarif dan Dokumen Internal yang terdapat di Product Catalog bersifat
          <b>rahasia</b>
          <i>(confidential)</i>,
          terbatas hanya untuk karyawan Telkom.</h6>
        </li>
        <li>
          <h6>Berkewajiban menjaga kerahasiaan informasi Product Catalog.</h6>
        </li>
        <li>
          <h6>
            Tidak menyalahgunakan informasi yang diperoleh sehingga menyebabkan
            gangguan, hingga kerugian bagi perusahaan.
          </h6>
        </li>
        <li>
          <h6>
            Bertanggung jawab apabila terjadi penggunaan yang tidak benar terhadap
            informasi tersebut.
          </h6>
        </li>
      </ol>
      <b-form-checkbox class="mt-2" v-model="isChecked">Saya menyetujui dan memahami <b>Non-Disclosure Agreement</b> di atas</b-form-checkbox>
      <div class="d-flex justify-content-center align-items-center">
        <b-button size="sm" variant="light" class="mt-3 mr-2 w-25">Cancel</b-button>
        <b-button size="sm" @click="authorizedDownload" variant="primary" class="mt-3 w-25">Ok</b-button>
      </div>
    </b-modal>
    <b-card v-if="isLoading">
      <b-card-text class="pl-5">
        <SkeletonContainer />
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col cols="12" md="2">
            <div class="form-group">
              <label for="search-input">Search:</label>
              <b-form-input 
                id="search-input"
                v-model="searchWord"
                placeholder="Search..." 
              />
            </div>
          </b-col>
          <b-col cols="12" md="3">
            <div class="form-group">
              <label for="select">Filter By:</label>
              <b-form-select 
                id="filterBy"
                v-model="filterBy"
                :options="optionsFilter"
              />
            </div>
          </b-col>
          <b-col cols="12" md="3">
            <div class="form-group">
              <label v-if="showSort" for="sort-select">Sort by:</label>
              <b-form-select 
                v-if="showSort"
                v-model="sortCriteria"
                :options="optionsSort"
                id="sort-select"
              />
              <label v-if="showCategory" for="sort-select">Category:</label>
              <b-form-select 
                v-if="showCategory"
                v-model="categoryFilter"
                :options="optionsCategory"
                id="category-select"
              />
              <label v-if="showUploadDate" for="date-picker">Upload Date:</label>
              <b-form-datepicker 
                v-if="showUploadDate"
                v-model="uploadDate"
                id="date"
                placeholder="Start Date"
              />
              <label v-if="showDate" for="date-picker">Start Date:</label>
              <b-form-datepicker 
                v-if="showDate"
                v-model="startDate"
                id="date-picker-start"
                placeholder="Start Date"
              />
            </div>
          </b-col>
          <b-col cols="12" md="3">
            <label v-if="showDate" for="date-picker">End Date:</label>
            <b-form-datepicker 
                v-if="showDate"
                v-model="endDate"
                id="date-picker-end"
                placeholder="End Date"
              />
          </b-col>
        </b-row>
        <div>
          <b-card v-if="isLoading">
            <b-card-text class="pl-5">
              <SkeletonContainer />
            </b-card-text>
          </b-card>
        </div>
        <b-card-text  class="border border-danger font-weight-bolder rounded p-1 bold" v-for="(data, index) in nodinData" :key="index">
          <b-row>
            <b-col class="txt-xs-2" sm="4">
              <span><feather-icon size="16" icon="FileTextIcon" /> {{ data.name }} </span>
            </b-col>
            <b-col class="txt-xs-2 font-weight-lighter" sm="3">
              <span> Created Date : {{ data.date }} </span>
            </b-col>
            <b-col class="txt-xs-2 font-weight-lighter" sm="3">
              <span> Publish Date : {{ data.created_at ? data.created_at : '' }} </span>
            </b-col>
            <b-col class="txt-xs-2 font-weight-lighter" sm="2">
              <span>
                <!-- <b-link target="_blank" :href="'http://fegramax.net:9999/attachment?path='+ data.path"> -->
                <b-button @click="openModal(data.path)" class="mr-1 txt-xs-2 float-right" size="md" variant="primary">
                  <span><feather-icon size="14" icon="DownloadIcon" />Download</span>
                </b-button>
                <!-- </b-link> -->
              </span>
            </b-col>
          </b-row>
        </b-card-text>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Total {{ pagination.total }} entries
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="pagination.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="changePage"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
  BCard, BCardText,BLink,BAvatar,BRow,BCol,BTabs, BTab, BButton, BModal, BFormDatepicker, BFormInput, BFormSelect, BPagination, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BButtonGroup
} from 'bootstrap-vue'
import SkeletonContainer from './components/SkeletonContainer.vue'

export default {
  components: { BButton,BTabs, BTab,BRow,BCol,BCard,BPagination,BAvatar,BLink,BModal,AppCollapse,AppCollapseItem,BCardText,SkeletonContainer, BFormDatepicker, BFormInput, BFormSelect, BFormCheckboxGroup, BFormGroup, BFormCheckbox, BButtonGroup},
  data() {
    return {
      filterBy: null,
      sortCriteria: null,
      categoryFilter:null,
      downloadPath: '',
      startDate: '',
      endDate: '',
      uploadDate: '',
      nodinData: [],
      isLoading: false,
      show: false,
      currentPage: 1,
      perPage: 10,
      searchWord: '',
      optionsFilter: [
        { value: null, text: 'Please select an option' },
        { value: 'sort', text: 'By Sorting Data' },
        { value: 'date', text: 'By Document Date' },
        { value: 'uploadDate', text: 'By Upload Date' },
        { value: 'category', text: 'By Category' },
      ],
      optionsSort: [
        { value: null, text: 'Please select an option' },
        { value: 'ASC', text: 'ASC' },
        { value: 'DESC', text: 'DESC' },
      ],
      optionsCategory: [
        { value: null, text: 'Please select an option' },
        { value: 'Communication', text: 'Communication' },
        { value: 'Datacomm', text: 'Datacomm' },
        { value: 'Internet', text: 'Internet' },
        { value: 'Wireless', text: 'Wireless' },
      ],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      }
    }
  },
  computed: {
    showSort() {
      return this.filterBy === 'sort'
    },
    showDate() {
      return this.filterBy === 'date'
    },
    showUploadDate() {
      return this.filterBy === 'uploadDate'
    },
    showCategory() {
      return this.filterBy === 'category'
    }
  },
  // directives: {
  //   Ripple
  // },
  watch: {
    filterBy() {
      this.sortCriteria = ''
      this.uploadDate = null
      this.startDate = null
      this.endDate = null
      this.categoryFilter = ''
      this.searchWord = ''
    },
    perPage() {
      this.fetchZTI()
    },
    currentPage() {
      this.fetchZTI()
    },
    searchWord() {
      this.fetchZTI()
    },
    sortCriteria(){
      this.fetchZTI()
    },
    uploadDate(){
      this.fetchZTI()
    },
    endDate(){
      this.fetchZTI()
    },
    categoryFilter(){
      this.fetchZTI()
    }
  },
  mounted(){
    this.fetchZTI()
    
  },
  methods: {
    openModal(path) {
      this.downloadPath = path
      this.show = true
    },
    authorizedDownload() {
      if(this.isChecked){
        window.location.href = `http://fegramax.net:9999/attachment?path=${this.downloadPath}`
        this.isChecked = false
        this.show = false
      }else{
        this.$notifOnClick(
          'Forbidden!', 
          "Downloading this file is strictly prohibited. Unauthorized access or distribution of this content is against our policy and may result in serious consequences, including legal action. Please respect these restrictions and do not attempt to download or share this file without proper authorization", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
        this.isChecked = false
        this.show = false
      }
    },
    fetchZTI() {
      this.isLoading = true
      this.$http.get('http://fegramax.net:9999/attachment/list', {
        params: {
          kode:this.$route.params.key,
          page: this.currentPage,
          perPage: this.perPage,
          order: this.sortCriteria,
          type:'ZonaTarifInner', 
          startDate: this.startDate,
          endDate: this.endDate,
          category: this.categoryFilter,
          s: this.searchWord.toString().trim(),
          createdDate : this.uploadDate
        },
        withCredentials: false,
      })
      .then(response => {
        this.currentPage = response.data.current_page
        this.pagination.total = response.data.total
        this.nodinData = response.data.data
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    changePage(page) {
      this.currentPage = page
    }
  }
}
</script>

<style>
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}

.title {
  color:black;
}

.no-data > .card-body{
  padding:1rem !important;
}

.no-data > .card-body > .card-title{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2em;
  color: gray;
}

.modal-header {
  background-color: red !important;
}
.modal-title {
  color:white !important;
  font-weight: 600
}
</style>